import { lazy } from 'react';
import { authModules } from 'app/auth';

const ForgotPassword = lazy(() => import('./ForgotPassword'));

const ForgotPasswordConfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false
				},
				toolbar: {
					display: false
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	},
	auth: authModules.notloggedin,
	routes: [
		{
			path: '/forgotpassword',
			element: <ForgotPassword />
		}
	]
};

export default ForgotPasswordConfig;
